import { render, staticRenderFns } from "./ArrivedRecord.vue?vue&type=template&id=1f4bc6d5&scoped=true&"
import script from "./ArrivedRecord.vue?vue&type=script&lang=js&"
export * from "./ArrivedRecord.vue?vue&type=script&lang=js&"
import style0 from "./ArrivedRecord.vue?vue&type=style&index=0&id=1f4bc6d5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4bc6d5",
  null
  
)

export default component.exports